import { useLocale } from '../i18n/context'

export default function GrammarListPage() {
  const { tr } = useLocale()
  const gl = tr.grammarList
  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', letterSpacing: '-0.02em', marginBottom: 8 }}>
        {gl.title}
      </h1>
      <p style={{ color: 'var(--text-secondary)' }}>{gl.subtitle}</p>
    </div>
  )
}
